import { render, staticRenderFns } from "./qyClassMan1.vue?vue&type=template&id=356f47fc&scoped=true"
import script from "./qyClassMan1.vue?vue&type=script&lang=js"
export * from "./qyClassMan1.vue?vue&type=script&lang=js"
import style0 from "./qyClassMan1.vue?vue&type=style&index=0&id=356f47fc&prod&lang=scss"
import style1 from "./qyClassMan1.vue?vue&type=style&index=1&id=356f47fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356f47fc",
  null
  
)

export default component.exports